import { createContext, useContext, useState } from "react";

// Create Context
const FGBottlerSelectionContext = createContext();

// Context Provider Component
export const FGBottlerSelectionProvider = ({ children }) => {
    const [selectedData, setSelectedData] = useState([]);

    return (
        <FGBottlerSelectionContext.Provider value={{ selectedData, setSelectedData }}>
            {children}
        </FGBottlerSelectionContext.Provider>
    );
};

// Custom Hook for easy access
export const useFGBottlerSelection = () => useContext(FGBottlerSelectionContext);
